export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10103.ca643ed7.jpg";